import React from 'react'
import styled from 'styled-components'
import copy from 'copy-to-clipboard'
import { Block, Button, P } from '@mote/ui'
import { getReferrerCodeURL } from '../../shared/Auth'
import { CLIPBOARD_ANIMATION_TIMEOUT } from '@mote/helpers/constants'
import { Content } from '../Dashboard/components'
import { useTrackMutation } from '@mote/api'

export const AccountReferrals = ({ account }) => {
  const [copiedToClipboard, setCopiedToClipboard] = React.useState(false)
  const { mutate: track } = useTrackMutation()
  const url = getReferrerCodeURL(account.referrerCode)
  const { title, subtitle } = React.useMemo(() => {
    const texts = {
      title: 'Want to stay unlimited for free?',
      subtitle:
        "For every invited friend who joins mote, we'll add 30 days to your free trial, and your friend will get a 60-day Unlimited tier mote free trial, instead of the regular 30-day trial"
    }

    if (account.isPaid || account.isInstitution) {
      texts.title = "Share your code to extend your friends' Free trial"
      texts.subtitle =
        'Your friend will get a 60-day Unlimited tier mote free trial, instead of the regular 30-day trial.'
    }

    return texts
  }, [account])

  function sendURLToClipboard() {
    track({ variables: { event: 'Referrer URL Copied To Clipboard' } })
    copy(url)
    setCopiedToClipboard(true)
    setTimeout(() => setCopiedToClipboard(false), CLIPBOARD_ANIMATION_TIMEOUT)
  }

  return (
    <Content type='section' title={title} subtitle={subtitle} noPadding>
      <Block gap={12}>
        <P fontSize={15} fontWeight={400} lineHeight='120%'>
          Share this unique link to give friends a free trial:
        </P>
        <ReferralBox
          layout='horizontal'
          justify='space-between'
          align='center'
          gap={16}
          maxWidth={445}
        >
          <Url fontSize={15} fontWeight={400} lineHeight='120%'>
            {url}
          </Url>

          <Button
            variant='link'
            onClick={sendURLToClipboard}
            text={copiedToClipboard ? 'Copied!' : 'Copy link'}
          />
        </ReferralBox>
      </Block>
    </Content>
  )
}

const ReferralBox = styled(Block)`
  padding: 12.5px 16px;
  border: 1px solid #d1d1e0;
  border-radius: 4px;
`

const Url = styled(P)`
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
`
